/**
 * Color Primitives — raw palette values resolved via CSS custom properties.
 * Prefer semantic color tokens over using these directly.
 */

export const colorPrimitives = {
  // Navigation & brand
  navDark: "var(--p-navDark)",
  navBase: "var(--p-navBase)",
  navHover: "var(--p-navHover)",

  // Primary blues
  blueDark: "var(--p-blueDark)",
  blueMedium: "var(--p-blueMedium)",
  blueLight: "var(--p-blueLight)",
  blueAccent: "var(--p-blueAccent)",
  blueLink: "var(--p-blueLink)",

  // Grays — 8 canonical steps
  gray900: "var(--p-gray900)",
  gray700: "var(--p-gray700)",
  gray500: "var(--p-gray500)",
  gray400: "var(--p-gray400)",
  gray200: "var(--p-gray200)",
  gray100: "var(--p-gray100)",
  gray50: "var(--p-gray50)",
  gray25: "var(--p-gray25)",

  // White
  white: "var(--p-white)",

  // Accent
  blueSubheader: "var(--p-blueSubheader)",

  // Page-specific
  blueSlate: "var(--p-blueSlate)",
  footerBlue: "var(--p-footerBlue)",
  backgroundDark: "var(--p-backgroundDark)",
  landingMuted: "var(--p-landingMuted)",

  // Interactive
  goldHover: "var(--p-goldHover)",
} as const;
